module.exports = __webpack_public_path__ + "media/images/icons/compass-ddcd32e51b5e5478d155a6aa42ba5662.svg";